import {
  Row,
  Col,
  Card,
  Radio,
  Button,
  Typography,
  Popconfirm,
  Modal,
  Form,
  Input,
  Select,
} from "antd";

import { useEffect, useState } from "react";
import constant from "../config/constant";
import {
  DeleteOutlined,
  EditOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import {
  addRecipeAPI,
  deleteRecipeAPI,
  editRecipeAPI,
  getRecipesAPI,
} from "../api/recipes";

import { getCategoriesAPI } from "../api/category";

import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;
function Recipes() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [recipeForUpdate, setRecipeForUpdate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recipeList, seRecipesList] = useState([]);
  const [selectedCategoryID, selectCategory] = useState("");
  useEffect(() => {
    _getRecipes();
  }, []);
  const _getRecipes = async () => {
    const res = await getRecipesAPI();
    // if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
    seRecipesList(res?.data);
    _getCategories();
    // }
  };
  const showModal = () => {
    _getCategories();
    setIsModalOpen(true);
  };
  const _addRecipe = async (values) => {
    console.log("values", values);
    try {
      let res;
      if (recipeForUpdate) {
        res = await editRecipeAPI(recipeForUpdate, {
          name: values?.recipe_name,
          description: values?.description,
          category_id: values?.category,
          cooking_time: values?.cooking_time,
        });
      } else {
        res = await addRecipeAPI({
          name: values?.recipe_name,
          description: values?.description,
          category_id: values?.category,
          cooking_time: values?.cooking_time,
        });
      }
      if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        _getRecipes();
        setIsModalOpen(false);
        setRecipeForUpdate(null);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const _getCategories = async () => {
    const res = await getCategoriesAPI();
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      let dropdowns = [];
      res?.data.map((item) => {
        dropdowns.push({
          key: String(item?.id),
          label: item?.category_name,
          value: String(item?.id),
        });
      });
      setCategories(dropdowns);
    }
  };

  const deleteRecipe = async (id) => {
    const res = await deleteRecipeAPI(id);
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      _getRecipes();
    }
  };
  const _editRecipe = (d) => {
    console.log("xxxx", d);
    form.setFieldsValue({
      selectedCategoryID: String(d?.category_id),
      recipe_name: d?.name,
      description: d?.description,
      cooking_time: d?.cooking_time,
    });
    selectCategory(String(d?.category_id));
    setRecipeForUpdate(d?.id);
    setIsModalOpen(true);
  };

  console.log("categories", categories);
  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="All Recipes"
              extra={
                <>
                  <Radio.Group defaultValue="a">
                    <Radio.Button value="a" onClick={showModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>Add New recipe</span>
                    </Radio.Button>
                  </Radio.Group>
                </>
              }
            >
              <div className="ant-list-box table-responsive m-25">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th>
                        <div className="text-center">ID</div>
                      </th>
                      <th>
                        <div className="text-center">Category</div>
                      </th>
                      <th>
                        <div className="text-center">Name</div>
                      </th>
                      <th>
                        <div className="text-center">Cooking Time</div>
                      </th>
                      <th>
                        <div className="text-center">Description</div>
                      </th>
                      <th>
                        <div className="text-center">Action</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {recipeList &&
                      recipeList.length > 0 &&
                      recipeList.map((d, index) => (
                        <tr key={index}>
                          <td>
                            <div className="text-xs text-center">{d?.id}</div>
                          </td>
                          <td>
                            <div className="text-xs text-center">
                              {d?.category_name}
                            </div>
                          </td>
                          <td>
                            <div className="text-xs text-center">
                              <Title level={5}>{d?.name}</Title>
                            </div>
                          </td>
                          <td>
                            <div className="text-xs text-center">
                              {d?.cooking_time}
                            </div>
                          </td>
                          <td>
                            <div
                              className="text-xs text-left"
                              style={{
                                minWidth: 300,
                                textOverflow: "ellipsis",
                                whiteSpace: "break-spaces",
                                wordBreak: "break-word",
                              }}
                            >
                              {d?.description}
                            </div>
                          </td>
                          <td>
                            <div
                              className="col-action text-right"
                              style={{ justifyContent: "center" }}
                            >
                              <Button
                                type="dashed"
                                className="darkbtn"
                                onClick={() => _editRecipe(d)}
                              >
                                <EditOutlined style={{ fontSize: "16px" }} />
                                Edit
                              </Button>
                              <Button
                                type="dashed"
                                className="darkbtn"
                                style={{ marginLeft: 10 }}
                                onClick={() =>
                                  navigate("/recipeDetails", {
                                    recipe_id: d?.id,
                                  })
                                }
                              >
                                <FileAddOutlined style={{ fontSize: "16px" }} />
                                Details
                              </Button>
                              <Popconfirm
                                title="Delete this user? "
                                description="Are you sure to delete this user?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => deleteRecipe(d?.id)}
                              >
                                <Button
                                  type="dashed"
                                  style={{ marginLeft: 10 }}
                                >
                                  <DeleteOutlined
                                    className="text-danger"
                                    style={{
                                      fontSize: "16px",
                                    }}
                                  />
                                  <span className="text-danger">Delete</span>
                                </Button>
                              </Popconfirm>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title="Add Recipe"
        open={isModalOpen}
        okCancel={false}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addRecipe}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label="Category"
            name="category"
            rules={[
              {
                required: true,
                message: "Please select category!",
              },
            ]}
          >
            <Select
              placeholder="Select Category"
              value={selectedCategoryID}
              options={categories}
              // onSelect={_chooseCategory}
            />
          </Form.Item>
          {/* <Dropdown
            menu={{
              categories,
              onClick,
            }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Hover me, Click menu item
                <DownOutlined />
              </Space>
            </a>
          </Dropdown> */}
          <Form.Item
            label="Recipe Name"
            name="recipe_name"
            rules={[
              {
                required: true,
                message: "Please enter recipe name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 18,
            }}
            style={{
              maxWidth: 600,
            }}
            label="Cooking Time"
            name="cooking_time"
            rules={[
              {
                required: true,
                message: "Cooking time",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            style={{ maxWidth: 600 }}
            label="Description"
            name="description"
            rules={[
              {
                required: true,
                message: "Description",
              },
            ]}
          >
            <textarea style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 20,
              span: 4,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default Recipes;
